import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { TableModal, useTableModalLoadingData } from '../../TableModal'

import {
  QA_NAME_REQUEST_ARCHIVED_PIPELINES_MODAL,
  QA_NAME_REQUEST_ARCHIVED_PIPELINES_RESTORE_BUTTON,
  REQUEST_ARCHIVED_PIPELINES_MODAL_PAGINATION,
} from './RequestArchivedPipelinesModal.constants'
import {
  getRequestArchivedPipelinesModalCanSelectOnlyOneNotification,
  getRequestArchivedPipelinesModalItemsFromResponse,
  getRequestArchivedPipelinesModalRestoreNotification,
  getRequestArchivedPipelinesModalTableColumns,
} from './RequestArchivedPipelinesModal.utils'
import { RequestArchivedPipelinesModalTableRow } from './RequestArchivedPipelinesModalTableRow'

function RequestArchivedPipelinesModal({
  loadArchivedPipelines,
  onClose,
  onRestore,
}) {
  const { t } = useTranslation()

  const tableColumns = getRequestArchivedPipelinesModalTableColumns()

  const {
    checkIsItemSelected,
    handlePrependNotification,
    handleRemoveNotification,
    handleSelect,
    isInitLoading,
    notifications,
    selected,
    setLoading,
    tableItems,
  } = useTableModalLoadingData({
    getItemsFromResponse: getRequestArchivedPipelinesModalItemsFromResponse,
    initialNotifications: [
      getRequestArchivedPipelinesModalRestoreNotification(t),
    ],
    loadItems: loadArchivedPipelines,
  })

  const items = tableItems?.items || EMPTY_LIST

  useEffect(() => {
    const canSelectOnlyOneNotification =
      getRequestArchivedPipelinesModalCanSelectOnlyOneNotification(t)

    if (selected.length > 0) {
      handlePrependNotification(canSelectOnlyOneNotification)
    } else {
      handleRemoveNotification(canSelectOnlyOneNotification.id)
    }
  }, [handlePrependNotification, handleRemoveNotification, selected.length])

  function handleRestore() {
    if (selected[0]) {
      setLoading(true)

      onRestore(selected[0].id).finally(() => {
        setLoading(false)
      })
    }
  }

  return (
    <TableModal
      Pagination={null}
      Search={null}
      SelectionToolbar={null}
      actionsProps={{
        buttonAttachProps: {
          disabled: !selected[0],
          qaName: QA_NAME_REQUEST_ARCHIVED_PIPELINES_RESTORE_BUTTON,
          text: 'Request.ArchivedPipelinesModalRestoreButtonKey',
          onClick: handleRestore,
        },
        buttonCancelProps: {
          onClick: onClose,
        },
      }}
      counterProps={{
        count: items.length,
        text: 'Request.ArchivedPipelinesModalCounterKey',
      }}
      headerProps={{
        text: 'Modal.ArchivedPipelinesModalTitleKey',
        onClose,
      }}
      isInitLoading={isInitLoading}
      notifications={notifications}
      paginationProps={{
        pagination: REQUEST_ARCHIVED_PIPELINES_MODAL_PAGINATION,
      }}
      qaName={QA_NAME_REQUEST_ARCHIVED_PIPELINES_MODAL}
      selected={selected}
      tableItems={items}
      tableProps={{
        TableRow: RequestArchivedPipelinesModalTableRow,
        checkIsItemSelected,
        columns: tableColumns,
        headerRowProps: {
          resizable: false,
          withCellBorder: false,
        },
        items,
        rowProps: {
          hideCheckbox: selected.length > 0,
          onSelect: handleSelect,
        },
      }}
      onTableModalClose={onClose}
    />
  )
}

export default RequestArchivedPipelinesModal
